import { BaseApi } from "../BaseApi";

let API: BaseApi | null = null;

function getApiInstance(): BaseApi {
  if (!API) {
    API = new BaseApi();
  }
  return API;
}

function buildUrl(
  baseUrl: string,
  params?: { [key: string]: string | number }
) {
  const queryParams = new URLSearchParams();
  if (params) {
    Object.keys(params).forEach((key) => {
      const val = params[key];
      if (val !== undefined && val !== null && val !== "") {
        queryParams.append(key, val.toString());
      }
    });
  }
  const query = queryParams.toString();
  return query ? `${baseUrl}?${query}` : baseUrl;
}

function getAffiliates(params: {
  limit: number;
  skip: number;
  keyword?: string;
  owner?: string;
  country?: string;
  startDate?: string;
  endDate?: string;
}) {
  const baseUrl = "affiliates";
  const url = buildUrl(baseUrl, params);

  try {
    return getApiInstance().get(url);
  } catch (error) {
    console.error("Error fetching Affiliates:", error);
  }
}

function createAffiliateApi(params: {
  country: string;
  comment: string;
  description: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
  availableCountries?: string[];
  prices?: { country: string; price: number }[];
}) {
  const baseUrl = "affiliates";
  const url = buildUrl(baseUrl);

  try {
    return getApiInstance().post(url, params);
  } catch (error) {
    console.error("Error creating Affiliate:", error);
  }
}

function deleteAffiliateApi(params: { ids: string[] }) {
  const baseUrl = "affiliates";
  const url = `${baseUrl}/delete`;
  try {
    return getApiInstance().axiosInstance.put(url, { ids: params.ids }, { timeout: 15000 });
  } catch (error) {
    console.error("Error deleting affiliate:", error);
    throw error;
  }
}

function updateAffiliateVisibilityApi(params: {
  id: string;
  visibleInMarketplace: boolean;
}) {
  const url = `affiliates/visibility/${params.id}`;
  const body = { visibleInMarketplace: Boolean(params.visibleInMarketplace) };
  return getApiInstance().axiosInstance.put(url, body, { timeout: 15000 });
}

function updateAffiliateApi(params: {
  id: string;
  comment: string;
  description: string;
  name: string;
  price: number;
  productImage: string;
  quantity: number;
}) {
  const baseUrl = "affiliates";
  const url = `${baseUrl}/${params.id}`;
  try {
    return getApiInstance().put(url, params);
  } catch (error) {
    console.error("Error updating Affiliate:", error);
  }
}

function getAffiliate(params: { id: string }) {
  const baseUrl = "affiliates";
  const url = `${baseUrl}/${params.id}`;
  try {
    return getApiInstance().get(url);
  } catch (error) {
    console.error("Error fetching Affiliate:", error);
  }
}

function parseProductUrlApi(params: { url: string }) {
  const url = "affiliates/parse-product-url";
  try {
    return getApiInstance().post(url, params);
  } catch (error) {
    console.error("Error parsing product URL:", error);
    throw error;
  }
}

export {
  getAffiliates,
  createAffiliateApi,
  getAffiliate,
  updateAffiliateApi,
  deleteAffiliateApi,
  updateAffiliateVisibilityApi,
  parseProductUrlApi,
};
